import StringConstants from '../constants/StringConstants';

export const stringHelper = {
  camelCaseToUnderScoreAllCaps(str: string) {
    return str
      .replace(/([A-Z])/g, '_$1')
      .toLowerCase()
      .toUpperCase();
  },
  capitalize(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },
  currentYear() {
    return new Date().getFullYear();
  },
  pluralize(num: number, singular: string, plural: string) {
    return `${num} ${num === 1 ? singular : plural}`;
  },
  pluralizeWord(num: number, singular: string, plural: string) {
    return `${num === 1 ? singular : plural}`;
  },

  /**
   * Get a regex for the dashboard routes
   *
   * @param excludeList - a list of paths to exclude
   *  ex: ['dashboard/listing']
   * @param pathList - a list of possible paths to include
   *
   * @returns {String} - a regex of possible sub routes for the dashboard
   *  ex: '(overview|find-tenants|manage-tenants)'
   */
  getAllowDashboardParamsRegexByPaths({
    excludeList = [],
    pathList = [],
  }: {
    excludeList: Array<string>;
    pathList: Array<string>;
  }) {
    const filteredPathList = pathList.filter((value) => {
      return excludeList.includes(value) === false;
    });

    const subPathList = filteredPathList.map((value) => {
      return stringHelper.getLastPieceFromPath(value) || '';
    });

    const formattedRegex = (subPathList.length > 0 && `(${subPathList.join('|')})`) || '';

    return formattedRegex;
  },

  excludeWordsFromRegex({ excludeList = [], regexString = '' }: { excludeList: Array<string>; regexString: string }) {
    const filteredResponse = regexString
      .replace('(', '')
      .replace(')', '')
      .split('|')
      .filter((word) => {
        return !excludeList.includes(word);
      });

    const formattedRegex = (filteredResponse[0] !== '' && `(${filteredResponse.join('|')})`) || '';

    return formattedRegex;
  },

  getPageTitle(titleContent: string, brand: string) {
    const formattedBrand =
      StringConstants.FORMATTED_BRAND_NAMES_RENTAL[brand as keyof typeof StringConstants.FORMATTED_BRAND_NAMES_RENTAL];
    return `${titleContent} | ${formattedBrand}`;
  },
  wrapText(text = '', maxCharacters: number) {
    return `${text.slice(0, maxCharacters)}${text.length >= maxCharacters ? '…' : ''}`;
  },
  underScoreToSpaces(str = '') {
    return str.replace(/_/g, ' ');
  },
  capitalizeWords(str: string) {
    return str.split(' ').map(this.capitalize).join(' ');
  },
  getUrlQueryParams() {
    const query = window.location.search.substring(1);

    if (!query) {
      return false;
    }

    const queryString: { [key: string]: string | Array<string> } = {};
    const vars = query.split('&');
    let i: number;
    let pair: Array<string>;

    for (i = 0; i < vars.length; i++) {
      pair = vars[i].split('=');
      const existing = queryString[pair[0]];
      if (typeof existing === 'undefined') {
        queryString[pair[0]] = decodeURIComponent(pair[1]);
      } else if (typeof existing === 'string') {
        queryString[pair[0]] = [existing, decodeURIComponent(pair[1])];
      } else {
        existing.push(decodeURIComponent(pair[1]));
      }
    }
    return queryString;
  },
  getCookieByName(name: string) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
      return parts.pop()?.split(';').shift();
    }
    return null;
  },
  getLastPieceFromPath(pathname: string) {
    if (!pathname) {
      return '';
    }

    return pathname.split(/[/]+/).pop();
  },
  stripDollarSign(value: string) {
    return value.replace(/\$/g, '');
  },
  sanitizeReactInput(string: string) {
    let parsed = '';

    // react cannot inject "{" gracefully in strings
    // e.g. <div>`${"{"}`</div> will break
    if (string) {
      parsed = string.replace(/\{|\}/g, '');
    }

    return parsed;
  },
  validateEmail: (email: string) => {
    /**
     * https://stackoverflow.com/a/63800465
     */
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
};

export default stringHelper;
